import {
    ChooseMinuteStyle,
    ChooseStyleData
} from 'components/minute/layout/CreateMinuteStyle/ChooseMinuteStyle';
import { useBackgroundImageMarker } from 'hooks/marker/useBackgroundImageMarker';
import { useRef, useState } from 'react';
import { GiveMeMap } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    onCreateClicked: (styleData: ChooseStyleData) => void;
}

export const CreateMinuteStyle = (props: Props): JSX.Element => {
    const mapRef = useRef<MapRef>();
    const [style, setStyle] = useState<ChooseStyleData>({
        type: 'basic',
        url: 'mapbox://styles/koudelka/cld4go9oi000k01p7wci751am'
    });

    const backgroundImageMarker = useBackgroundImageMarker();

    const backgroundMarker =
        style.type === 'image'
            ? backgroundImageMarker.getBackgroundMarker(
                  [style.url],
                  style.imageUrl,
                  style.coordinates
              )
            : null;

    return (
        <S_CreateMinuteStyle className={props.className}>
            <GiveMeMap
                mapRef={mapRef}
                map={{
                    mapboxAccessToken: process.env.REACT_APP_MAPBOX_TOKEN,
                    initialViewState: {
                        latitude: 63.42842,
                        longitude: 10.375392,
                        zoom: 13.24
                    },
                    mapStyle: style.url
                }}
                markers={[backgroundMarker].filter(Boolean)}
            />
            <S_Over>
                <S_Center>
                    <ChooseMinuteStyle
                        mapRef={mapRef}
                        onStyleSelected={(styleData) => {
                            setStyle(styleData);
                        }}
                        onCreateClicked={() => {
                            props.onCreateClicked(style);
                        }}
                    />
                </S_Center>
            </S_Over>
        </S_CreateMinuteStyle>
    );
};

const S_CreateMinuteStyle = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
`;

const S_Over = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Center = styled.div`
    pointer-events: all;
`;
